import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CentreOption, EducationObservation} from "../education-observation.model";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {Router} from "@angular/router";
import {EducationObservationService} from "../education-observation.service";
import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
import {LogService} from "../../../../../services/log.service";
import {MatDialog} from "@angular/material/dialog";
import {
  AddEditEducationObservationComponent
} from "../add-edit-education-observation/add-edit-education-observation.component";
import {Observable, Subject} from "rxjs";
import {map, takeUntil} from "rxjs/operators";
import {FormControl} from "@angular/forms";
import {EmployeeService} from "../../../../../services/employee.service";
import {CentreService} from "../../../../../services/centre.service";
import {MatSelectChange} from "@angular/material/select";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {FinancialYearService} from "../../../../../services/financial-year.service";
import {needConfirmation} from "../../../../../confirm-dialog/confirm-dialog.decorator";
import {
  getCurrentUserLevel,
  levelFromRole,
  ObservationLevel,
  TEACHER_TYPE_LEAD_TEACHER,
  TEACHER_TYPE_SENIOR_TEACHER,
  TEACHER_TYPE_TEACHING_TEAM
} from "../education-observation-access";


@Component({
  selector: 'app-education-observation-list',
  templateUrl: './education-observation-list.component.html',
  styleUrls: ['./education-observation-list.component.scss']
})
export class EducationObservationListComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();

  displayedColumns: string[] = [
    'srNo',
    'sessionDate',
    'observerName',
    'teacherName',
    'centreName',
    'childName',
    'sessionType',
    'subject',
    'actions'
  ];

  dataSource = new MatTableDataSource<EducationObservation>([]);
  allObservations: EducationObservation[] = [];
  startDate = new FormControl<Date | null>(null);
  endDate = new FormControl<Date | null>(null);


  // selectedCentre = 'All';
  // mTeacher = 'All';

  centres$!: Observable<CentreOption[]>;
  SelectCentre = new FormControl('')
  mTeacher: string | null = null
  selectedCentre: string | null = null
  teachers$!: Observable<any[]>
  // selectedCentre = 'All';
  userData: any
  isLoading = false;  // New loading flag
  mFilteredData: any[] = []
  teacherType: string = 'All';

  /** Level of the signed-in user; decides which records and filters are available. */
  viewerLevel: ObservationLevel = getCurrentUserLevel();
  /** Teacher Type options the viewer is allowed to filter on (levels below their own). */
  teacherTypeOptions: string[] = [];
  hasNoAccess = false;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private educationService: EducationObservationService,
    private mLogService : LogService,
    private router: Router,
    private dialog : MatDialog,
    private readonly mEmployeeService: EmployeeService,

    private readonly centreService: CentreService,
    private readonly financialYearService: FinancialYearService,
  ) {
    // Only teachers whose observations this user could see, so the filter can't
    // offer a name that always returns nothing.
    this.teachers$ = this.mEmployeeService.getTeachers().pipe(
      map(teachers => teachers.filter(teacher => levelFromRole(teacher?.role) < this.viewerLevel)))
    this.userData = JSON.parse(localStorage.getItem('userData')!)
    if (this.userData.role == 'Centre') {
      this.centres$ = centreService.getSortedCenterListByRole(this.userData.centreCode)
    } else if (this.userData.role != 'Centre') {
      this.centres$ = centreService.getAllCentres()
    }
  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate.setValue(fy.startDate);
    this.endDate.setValue(fy.endDate);
    this.teacherTypeOptions = this.buildTeacherTypeOptions();
    this.hasNoAccess = this.viewerLevel <= ObservationLevel.TEACHING_TEAM;
    this.loadList();
  }

  /**
   * A viewer may only filter by the levels they can actually see, i.e. those
   * strictly below their own.
   */
  private buildTeacherTypeOptions(): string[] {
    const options: string[] = [];
    if (this.viewerLevel > ObservationLevel.TEACHING_TEAM) options.push(TEACHER_TYPE_TEACHING_TEAM);
    if (this.viewerLevel > ObservationLevel.SENIOR_TEACHER) options.push(TEACHER_TYPE_SENIOR_TEACHER);
    if (this.viewerLevel > ObservationLevel.LEAD_TEACHER) options.push(TEACHER_TYPE_LEAD_TEACHER);
    return options;
  }

  loadList() {
    // Only records the signed-in user is above in the hierarchy.
    this.educationService.getVisibleObservations().pipe(takeUntil(this._destroyed$)).subscribe((data: any[]) => {
      this.allObservations = data;
      this.dataSource = new MatTableDataSource(this.allObservations);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  applyFilter(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    this.dataSource.filter = input.value.trim().toLowerCase();
  }

  search() {
    this.isLoading = true;

    const centre = this.SelectCentre.value || 'All';
    const teacher = this.mTeacher || 'All';
    const teacherType = this.teacherType || 'All';
    const from = this.startDate.value
      ? new Date(new Date(this.startDate.value).setHours(0, 0, 0, 0))
      : null;

    const to = this.endDate.value
      ? new Date(new Date(this.endDate.value).setHours(23, 59, 59, 999))
      : null;

    let filtered = [...this.allObservations];

    // ← This was commented out, now fixed
    if (centre !== 'All') {
      filtered = filtered.filter(item => item.centreCode === centre);
    }
    // Teacher type filter
    if (teacherType !== 'All') {
      filtered = filtered.filter((item:any) => item?.teacherType === teacherType);
    }


    if (teacher !== 'All') {
      filtered = filtered.filter(item => item.teacherName === teacher);
    }

    if (from && to) {
      filtered = filtered.filter(item => {
        const sessionDate = item.sessionDate?.toDate();
        return sessionDate >= from && sessionDate <= to;
      });
    }

    this.dataSource = new MatTableDataSource(filtered);
    this.dataSource.sort = this.sort!;
    this.dataSource.paginator = this.paginator!;
    this.paginator?.firstPage();

    this.isLoading = false;
  }



  onCentreChange(event: MatSelectChange) {
    this.selectedCentre = event.value;
  }





  clearAll() {
    this.selectedCentre = 'All';
    this.SelectCentre.setValue('All');
    this.mTeacher = 'All';

    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate.setValue(fy.startDate);
    this.endDate.setValue(fy.endDate);

    this.dataSource = new MatTableDataSource(this.allObservations);
    this.dataSource.sort = this.sort!;
    this.dataSource.paginator = this.paginator!;

    this.paginator?.firstPage();
  }






  fetchByCenter($event: MatSelectChange) {
    this.selectedCentre = $event.value
    console.log('FETCH CENTER SELECTED IN EDUCATION')

    // this.educationService.getEducation($event.value).subscribe(re => {
    //     this.educationData = re
    //     this.dataSource = new MatTableDataSource(this.educationData);
    //     this.dataSource.sort = this.sort!;
    //     this.dataSource.paginator = this.paginator!;
    //     console.log(this.dataSource.data)
    // })
  }

  // addObservation() {
  //   this.router.navigate(['/home/education/add-education-observation']);
  // }
  addObservation() {
    this.dialog.open(AddEditEducationObservationComponent, {
      width: '900px',
      maxHeight: '80vh',
      disableClose: true,
      autoFocus: false,
      data: null
    });
  }

downloadExcelSheet() {
  if (!this.dataSource?.data?.length) {
    return;
  }

  const exportData = this.dataSource.data.map((row: any, index: number) => ({
    'Sr No': index + 1,
    'Session Date': row.sessionDate?.toDate
      ? row.sessionDate.toDate().toLocaleDateString()
      : '',
    'Observer Name': row.observerName || '',
    'Teacher Name': row.teacherName || '',
    'Centre Name': row.centreName || '',
    'Child Name': row.childName || 'NA',
    'Session Type': row.sessionType || '',
    'Subject': row.subject || ''
  }));

  const worksheet: XLSX.WorkSheet =
    XLSX.utils.json_to_sheet(exportData);

  // Column widths
  worksheet['!cols'] = [
    { wch: 6 },   // Sr No
    { wch: 14 },  // Date
    { wch: 20 },  // Observer
    { wch: 20 },  // Teacher
    { wch: 25 },  // Centre
    { wch: 20 },  // Child
    { wch: 18 },  // Session
    { wch: 20 }   // Subject
  ];

  const workbook: XLSX.WorkBook = {
    Sheets: { 'Education Observation': worksheet },
    SheetNames: ['Education Observation']
  };

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const blob = new Blob([excelBuffer], {
    type:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  saveAs(
    blob,
    `Education_Observation_${new Date().getTime()}.xlsx`
  );
}


edit(row: EducationObservation) {
    this.dialog.open(AddEditEducationObservationComponent, {
      width: '900px',
      maxHeight: '80vh',
      disableClose: true,
      autoFocus: false,
      data: row.id
    });
  }
  view(row: any) {
    const activity = {
      date: new Date().getTime(),
      section: 'Education Observation',
      action: 'Viewed',
      description: `Education observation viewed by user`,
      currentIp: localStorage.getItem('currentip')!
    };
    this.mLogService.addLog(activity);
    this.router.navigate(['/home/education/view-education-observation', row.id]);
  }



  @needConfirmation({
    title: 'Delete Observation',
    message: 'Are you sure you want to delete this education observation?'
  })
  delete(id: string | undefined) {
    if (!id) return;

    this.educationService.deleteRow(id)
      .then(() => {
        const activity = {
          date: new Date().getTime(),
          section: 'Education Observation',
          action: 'Deleted',
          description: `Education observation deleted by user`,
          currentIp: localStorage.getItem('currentip')!
        };
        this.mLogService.addLog(activity);
      })
      .catch((error) => {
        console.error('Error deleting observation:', error);
      });
  }


  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;
}
